import { render } from "./AgenzieDataTable.vue?vue&type=template&id=81cab218"
import script from "./AgenzieDataTable.vue?vue&type=script&lang=js"
export * from "./AgenzieDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__